import React from 'react';
import {Link} from 'react-router-dom';
import Avatar from '../Avatar';
import {Button} from "../Button";
import createLink from "../../../libs/createLink";
import {isNoFollowProfil} from "../../../libs/helper";

const IgnoreUser = (props) => {
    let relLinkProfil = isNoFollowProfil(props) ? { rel: "nofollow" } : {};
    return (
        <div className="ignored-user">
            <Link to={createLink("userProfile", props)} {...relLinkProfil}>
                <Avatar avatar={props.profile && (props.profile.avatar || "")}
                        gender={props.profile && props.profile.gender} alt=""/>
            </Link>
            <div className="infos-user-wrapper">
                <Link to={createLink("userProfile", props)} {...relLinkProfil}>
                    <div className="username">{props.username || ""}</div>
                </Link>
            </div>
            <div className="btn-group">
                <Button size={"small"}
                        btnStyle={"primary-reverse"}
                        onClick={() => props.handleRemoveIgnoredUser(props._id)}
                        loading={props.userIgnoredLoading}
                        content={"Débloquer"}/>
            </div>
        </div>
    )
};

export default IgnoreUser;
